import React, { useState } from 'react';
import { Typography, Theme, styled } from '@mui/material';
import { COLOR_DARK } from '../../constants/color';

interface PublicPageSmallTextProps {
    onClick?: () => void;
    theme?: Theme;
    text: string;
    maxLines?: number;
    sx?: any;
}

export const PublicPageSmallText: React.FC<PublicPageSmallTextProps> = ({ text, sx, maxLines = 2 }) => {
    const [showMore, setShowMore] = useState<boolean>(false);
    const handleViewMoreToggle = () => {
        setShowMore((prev) => !prev);
    };

    const StyledPublicPageSmallText = styled(Typography)(({ theme }: { theme: Theme }) => ({
        fontFamily: 'Poppins',
        fontSize: '0.825rem',
        fontWeight: 400,
        fontStyle: 'normal',
        letterSpacing: '0.02rem',
        wordSpacing: '14%',
        lineHeight: '140%',
        color: COLOR_DARK,
        textAlign: 'justify',
        margin: theme.spacing(1, 0, 2, 0),
        display: '-webkit-box',
        overflow: 'hidden',
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        WebkitLineClamp: showMore ? 'none' : maxLines, // Show all lines when `showMore` is true
        position: 'relative', // For positioning "View More" button inside the same container
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.825rem',
            textAlign: 'justify',
        },
    }));

    return (
        <StyledPublicPageSmallText sx={sx} variant="body1">
            {text}
        </StyledPublicPageSmallText>
    );
};

